import { useQuery } from "@tanstack/react-query";
import { getCandidateDetails, getCandidateTimeline } from "../infrastructure/candidate-service";
import { useSelector } from "react-redux";
import { selectCurrentOrganizationId } from "@/modules/organizations/store/organizationSlice";

export function useCandidateDetail(candidateId: string) {
  const organizationId = useSelector(selectCurrentOrganizationId);

  const candidateQuery = useQuery({
    queryKey: ["candidate", organizationId, candidateId],
    queryFn: () => getCandidateDetails(organizationId, candidateId),
    enabled: !!candidateId,
  });

  const timelineQuery = useQuery({
    queryKey: ["candidate-timeline", organizationId, candidateId],
    queryFn: () => getCandidateTimeline(organizationId, candidateId),
    enabled: !!candidateId,
  });

  return {
    candidate: candidateQuery.data,
    timeline: timelineQuery.data,
    isLoading: candidateQuery.isLoading || timelineQuery.isLoading,
    error: candidateQuery.error || timelineQuery.error,
  };
}
